<div
  class="saas-ui saas-ui-size-default p-3 border-t border-gray-300"
  [ngClass]="{
    'bg-yellow-100':
      actionStep === 'override' &&
      layout === 'vertical' &&
      selectedCampaignType === 'ai',
  }">
  @if (layout === "vertical") {
    @if (actionStep === "choice") {
      <div class="flex justify-between items-center">
        <div class="flex gap-1 items-center">
          @if (selectedCampaignCount < 1) {
            <span class="material-symbols-outlined text-gray-500"> info </span>
          }
          <span class="text-gray-1000 b1">
            {{ getConfirmationMessage() }}
          </span>
        </div>
        <div class="flex gap-x-4 items-center">
          @if (!["ai", "unmapped"].includes(selectedCampaignType)) {
            <m-button
              type="secondary"
              [disabled]="!selectedCampaignCount"
              (click)="unmapCampaigns()"
              >Unmap
            </m-button>
          }
          <m-button
            type="secondary"
            [disabled]="!selectedCampaignCount"
            (click)="editMapping()"
            >Edit Mapping
          </m-button>
          @if (selectedCampaignType === "ai") {
            <m-button
              type="primary"
              [disabled]="!selectedCampaignCount"
              (click)="applyAIRecommendations()"
              >Approve
            </m-button>
          }
        </div>
      </div>
    } @else {
      <div class="w-full flex justify-between">
        <div class="flex gap-x-4 items-center">
          <span class="text-gray-1000 b1">
            {{ getConfirmationMessage() }}
          </span>
          <div class="w-[12rem]">
            <ng-template *ngTemplateOutlet="channelDropdown"></ng-template>
          </div>
          <div class="w-[12rem]">
            <ng-template *ngTemplateOutlet="tacticDropdown"></ng-template>
          </div>
          <div class="w-[12rem]">
            <ng-template *ngTemplateOutlet="segmentDropdown"></ng-template>
          </div>
        </div>
        <div class="flex gap-x-4 items-center">
          <m-button
            class="w-full"
            styleClass="w-full justify-center"
            type="secondary"
            (click)="abortTacticUpdateAndGoBack()">
            Cancel
          </m-button>
          <m-button
            class="w-max"
            styleClass="w-max justify-center"
            type="primary"
            (click)="updateDimension()">
            {{ selectedCampaignType === "ai" ? "Save & approve" : "Save" }}
          </m-button>
        </div>
      </div>
    }
  } @else {
    <div class="w-full h-full position-relative z-20">
      <div
        class="flex h-full flex-col gap-4 border border-solid border-gray-400 rounded-1 me-0 p-4"
        [ngClass]="{
          'mapped-tactic-dialog': selectedCampaignType !== 'unmapped',
        }"
        [class]="
          totalCampaigns > 50
            ? 'assign-tactic-dialog'
            : 'assign-tactic-dialog-for-less-records'
        ">
        <!-- Step 1: Two-button UI for unmapped campaigns when actionStep is 'choice' -->
        @if (selectedCampaignType === "unmapped" && actionStep === "choice") {
          <lib-ui-alpha-feature-enabler
            [clientId]="clientId"
            [brandId]="brandId"
            class="h-full">
            <ng-container phase="ai">
              <div class="h-full flex flex-col">
                <!-- Header with back button and title -->
                <div class="flex items-center justify-end w-full">
                  <span
                    class="material-symbols-outlined icon-regular text-blue-600 cursor-pointer"
                    (click)="abortTacticUpdate()"
                    >close</span
                  >
                </div>

                <!-- Content container - centered -->
                <div
                  class="flex flex-col gap-[1rem] items-center my-auto w-full">
                  <!-- Two action buttons -->
                  <span class="h5 mb-0 text-gray-1000">
                    Map {{ selectedCampaignCount }}
                    {{ selectedCampaignCount > 1 ? "Campaigns" : "Campaign" }}
                  </span>
                  <div class="flex flex-col gap-[1rem] w-full justify-center">
                    <m-button
                      class="w-full"
                      styleClass="w-full justify-center"
                      type="secondary"
                      (click)="editMapping()">
                      Edit Mapping
                    </m-button>
                    <div class="flex flex-col gap-2 w-full justify-center">
                      <m-button
                        class="w-full"
                        styleClass="w-full justify-center"
                        type="primary"
                        (click)="applyAIRecommendations()">
                        Approve AI Recommendations
                      </m-button>
                      <div class="text-gray-700 b1 w-full text-center">
                        Once applied, campaigns will be added for review
                      </div>
                    </div>
                  </div>
                  <!-- Information message -->
                </div>
              </div>
            </ng-container>
          </lib-ui-alpha-feature-enabler>
        }

        <!-- Step 2: Existing component content for unmapped campaigns when actionStep is 'override' OR for mapped campaigns -->
        @if (
          selectedCampaignType !== "unmapped" ||
          (selectedCampaignType === "unmapped" && actionStep === "override")
        ) {
          <div class="flex flex-col h-full justify-between">
            <!-- Header section -->
            @if (selectedCampaignType === "unmapped") {
              <div class="flex w-full items-center justify-between">
                <div class="flex items-center gap-[1rem]">
                  <lib-ui-alpha-feature-enabler
                    [clientId]="clientId"
                    [brandId]="brandId"
                    class="h-fit flex">
                    <ng-container phase="ai">
                      <span
                        class="material-symbols-outlined icon-regular text-blue-600 cursor-pointer"
                        (click)="goBack()"
                        >keyboard_arrow_left</span
                      >
                    </ng-container>
                  </lib-ui-alpha-feature-enabler>
                  <span class="h5 mb-0 text-gray-1000">
                    Map {{ selectedCampaignCount }} Selected
                    {{ selectedCampaignCount > 1 ? "Campaigns" : "Campaign" }}
                  </span>
                </div>
                <span
                  class="material-symbols-outlined icon-regular text-blue-600 cursor-pointer"
                  (click)="abortTacticUpdate()"
                  >close</span
                >
              </div>
            } @else {
              <div class="flex w-full">
                <div class="inline-block">
                  You've selected
                  <span class="fw-bold">{{ selectedCampaignCount }}</span>
                  {{ selectedCampaignCount > 1 ? "campaigns" : "campaign" }}
                  mapped to
                  <span class="fw-bold">{{
                    selectedDimensionOptions["tactic"].length
                  }}</span>
                  {{
                    selectedDimensionOptions["tactic"].length > 1
                      ? "tactics,"
                      : "tactic,"
                  }}
                  <span class="fw-bold">{{
                    selectedDimensionOptions["channel"].length
                  }}</span>
                  {{
                    selectedDimensionOptions["channel"].length > 1
                      ? "channels,"
                      : "channel,"
                  }}
                  and
                  <span class="fw-bold">{{
                    selectedDimensionOptions["segment"].length
                  }}</span>
                  {{
                    selectedDimensionOptions["segment"].length > 1
                      ? "segments"
                      : "segment"
                  }}
                </div>
                <div class="inline-block">
                  <span
                    (click)="abortTacticUpdate()"
                    class="material-symbols-outlined icon-small text-blue-600 cursor-pointer"
                    >close</span
                  >
                </div>
              </div>
            }

            <!-- Dropdown forms section -->
            <div class="flex flex-col gap-2">
              <label for="channels">Channel</label>
              <ng-template *ngTemplateOutlet="channelDropdown"></ng-template>
            </div>
            <div class="flex flex-col gap-2">
              <label for="segments">Segment</label>
              <ng-template *ngTemplateOutlet="segmentDropdown"></ng-template>
            </div>
            <div class="flex flex-col gap-2">
              <label for="tactics">Tactic</label>
              <ng-template *ngTemplateOutlet="tacticDropdown"></ng-template>
            </div>
            @if (isGeoTestRunning) {
              <div class="flex w-full items-center justify-start gap-2">
                <span
                  class="flex material-symbols-outlined icon-small text-blue-600 cursor-default"
                  >info</span
                >
                <span class="b1 text-gray-800">Impacts Geo testing</span>
                <a
                  class="saas-text-link"
                  href="https://support.measured.com/article/wxdipxvthy-geo-test-overview"
                  >Learn more about Geo testing</a
                >
              </div>
            }
            @if (selectedCampaignType !== "unmapped") {
              <div class="flex w-full items-center justify-end mt-4">
                <m-button
                  type="secondary"
                  pTooltip="Unmap selected campaign(s) and use automated rules for campaign mapping"
                  tooltipPosition="top"
                  tooltipStyleClass="saas-tooltip"
                  class="inline-block me-3"
                  (click)="confirmToResetMapping()"
                  >Unmap</m-button
                >
                <m-button
                  type="secondary"
                  [disabled]="
                    !(
                      updateDimensionValue['tactic'] ||
                      updateDimensionValue['segment'] ||
                      updateDimensionValue['channel']
                    )
                  "
                  class="inline-block"
                  (click)="updateDimension()"
                  >Apply mapping</m-button
                >
              </div>
            }
            @if (selectedCampaignType === "unmapped") {
              <div class="flex w-full items-center justify-between mt-[1rem]">
                <m-button
                  class="w-full"
                  styleClass="w-full justify-center"
                  [disabled]="
                    !updateDimensionValue['tactic'].length &&
                    !updateDimensionValue['segment'].length &&
                    !updateDimensionValue['channel'].length
                  "
                  type="primary"
                  (click)="updateDimension()">
                  Add for Review
                </m-button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  <ng-template #channelDropdown>
    @if ((loading | async) === false) {
      <m-dropdown
        id="channels"
        [group]="true"
        optionLabel="channel"
        optionValue="channel"
        placeholder="Select Channel"
        [filter]="true"
        [showClear]="true"
        filterBy="channel"
        filterPlaceholder="Search"
        [options]="channels"
        [(ngModel)]="updateDimensionValue['channel']"
        styleClass="w-full"
        appendTo="body"
        (onClear)="updateDimensionValue['channel'] = ''"
        (formControlChange)="setValue(campaignDimension.channel, $event)"
        width="100%">
        <ng-template let-group pTemplate="group">
          @if (group.label && group.items.length > 0) {
            <span class="tactic-group-header">
              {{ group.label }}
            </span>
          }
        </ng-template>
        <ng-template let-item pTemplate="item">
          @switch (item.type) {
            @case ("divider") {
              <hr
                class="mt-0"
                [style]="{
                  padding: 'unset',
                  margin: 'unset',
                  background: 'none',
                }" />
            }
            @case ("button") {
              <span class="text-blue">{{ item.channel }}</span>
            }
            @case ("") {
              <span>{{ item.label }}</span>
            }
            @default {
              <span>
                {{ item.channel }}
              </span>
            }
          }
        </ng-template>
      </m-dropdown>
    }
    @if (loading | async) {
      <m-skeleton height="2rem" width="100%"></m-skeleton>
    }
  </ng-template>
  <ng-template #segmentDropdown>
    @if ((loading | async) === false) {
      <m-dropdown
        id="segments"
        [group]="true"
        optionLabel="segment"
        optionValue="segment"
        placeholder="Select Segment"
        [filter]="true"
        filterBy="segment"
        filterPlaceholder="Search"
        [options]="segments"
        [(ngModel)]="updateDimensionValue['segment']"
        styleClass="w-full"
        appendTo="body"
        [showClear]="true"
        (onClear)="updateDimensionValue['segment'] = ''"
        (formControlChange)="setValue(campaignDimension.segment, $event)">
        <ng-template let-group pTemplate="group">
          @if (group.label && group.items.length > 0) {
            <span class="tactic-group-header">
              {{ group.label }}
            </span>
          }
        </ng-template>
      </m-dropdown>
    }
    @if (loading | async) {
      <m-skeleton height="2rem" width="100%"></m-skeleton>
    }
  </ng-template>
  <ng-template #tacticDropdown>
    @if ((loading | async) === false) {
      <m-dropdown
        id="tactics"
        class="w-full"
        [group]="true"
        optionLabel="tactic"
        optionValue="tactic"
        placeholder="Select Tactic"
        [filter]="true"
        filterBy="tactic"
        filterPlaceholder="Search"
        [options]="tactics"
        [(ngModel)]="updateDimensionValue['tactic']"
        styleClass="w-full"
        appendTo="body"
        (onChange)="handleGeoTestMessageVisibility()"
        [showClear]="true"
        (onClear)="updateDimensionValue['tactic'] = ''"
        (formControlChange)="setValue(campaignDimension.tactic, $event)">
        <ng-template let-group pTemplate="group">
          @if (group.label && group.items.length > 0) {
            <span class="tactic-group-header">
              {{ group.label }}
            </span>
          }
        </ng-template>
        <ng-template let-item pTemplate="item">
          @switch (item.type) {
            @case ("divider") {
              <hr
                class="mt-0"
                [style]="{
                  padding: 'unset',
                  margin: 'unset',
                  background: 'none',
                }" />
            }
            @case ("button") {
              <span class="text-blue">{{ item.tactic }}</span>
            }
            @case ("") {
              <span>{{ item.label }}</span>
            }
            @default {
              <span>
                {{ item.tactic }}
                {{
                  geoTestStatusByDimension[item.tactic]
                    ? " (Geo test in progress)"
                    : ""
                }}
              </span>
            }
          }
        </ng-template>
      </m-dropdown>
    }
    @if (loading | async) {
      <m-skeleton height="2rem" width="100%"></m-skeleton>
    }
  </ng-template>
</div>
